import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import verifySSOProvider from '@/API/SSO/verifySSOProvider';

const useVerifySSOProvider = () => {
    return useMutation({
        mutationFn: verifySSOProvider,
        onSuccess: () => {
            toast.success('Provider has been verified!');
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.message ||
                    'Verification failed. Please try again.',
            );
        },
    });
};

export default useVerifySSOProvider;
